import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

const PickSchema = z.object({
  game_slug: z.string().min(1),
  game_name: z.string().min(1),
  numbers: z.array(z.number().int()).default([]),
  bonus_numbers: z.array(z.number().int()).default([]),
  label: z.string().optional().nullable(),
});

export const listSavedPicks = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { data, error } = await context.supabase
      .from("saved_picks")
      .select("id, game_slug, game_name, numbers, bonus_numbers, label, created_at")
      .order("created_at", { ascending: false })
      .limit(200);
    if (error) throw new Error(error.message);
    return data ?? [];
  });

export const createSavedPick = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d) => PickSchema.parse(d))
  .handler(async ({ data, context }) => {
    const { data: row, error } = await context.supabase
      .from("saved_picks")
      .insert({ ...data, user_id: context.userId })
      .select("id, game_slug, game_name, numbers, bonus_numbers, label, created_at")
      .single();
    if (error) throw new Error(error.message);
    return row;
  });

export const deleteSavedPick = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d) => z.object({ id: z.string().uuid() }).parse(d))
  .handler(async ({ data, context }) => {
    const { error } = await context.supabase
      .from("saved_picks")
      .delete()
      .eq("id", data.id);
    if (error) throw new Error(error.message);
    return { ok: true };
  });

export const bulkImportPicks = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d) => z.object({ picks: z.array(PickSchema).max(200) }).parse(d))
  .handler(async ({ data, context }) => {
    if (data.picks.length === 0) return { inserted: 0 };
    const rows = data.picks.map((p) => ({ ...p, user_id: context.userId }));
    const { error, count } = await context.supabase
      .from("saved_picks")
      .insert(rows, { count: "exact" });
    if (error) throw new Error(error.message);
    return { inserted: count ?? rows.length };
  });